export const getHeroStyles = () => ({
  marginTop: '5.8125rem',
})
